import React from 'react'
import { Button, Confirm, Icon } from 'semantic-ui-react'
// const log = require('debug')('app:components:confirmbutton')

const ConfirmButton = class Overview extends React.Component {
  constructor (props, context) {
    super(props, context)

    this.state = {
      open: false
    }
  }
  handleClick (e) {
    e.preventDefault()
    this.show()
  }
  show () {
    this.setState({ open: true })
  }
  handleConfirm () {
    const {onAction} = this.props
    this.setState({ open: false })

    if (onAction) {
      onAction()
    }
  }
  handleCancel () {
    this.setState({ open: false })
  }
  render () {
    const {children, hasIcon, icon} = this.props
    const iconName = icon || 'warning'
    const confirmStyle = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    }
    return (
      <span>
        <Button
          onClick={this.handleClick.bind(this)}
          negative={this.props.negative || false}
          secondary={this.props.secondary || false}
          color={this.props.color}
          floated={this.props.floated}
          size={this.props.size || 'small'}
        >
          {hasIcon ? <Icon name={iconName} /> : ''}
          {children}
        </Button>
        <Confirm
          style={confirmStyle}
          open={this.state.open}
          onCancel={this.handleCancel.bind(this)}
          onConfirm={this.handleConfirm.bind(this)}
          content={this.props.content || 'Are you sure you want to do this?'}
          confirmButton={this.props.confirmButton || 'Yes'}
        />
      </span>
    )
  }
}

export default ConfirmButton



// WEBPACK FOOTER //
// ./src/components/confirmbutton/index.js